{

"filterConfig": {
  "filterFields": [
    {
      "name": "trailerNumber",
      "displayLabel": "Trailer No",
      "dataType": "STRING",
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "trailerNumber"
      }
    },
    {
      "name": "transporterId",
      "displayLabel": "Transporter ID",
      "dataType": "STRING",
      "hasLookup": true,
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "transporterId"
      },
      "searchConfig": {
        "apiUrl": "v1/vendors/list",
        "selectFields": ["id", "name", "code"],
        "filterByKeys": ["NAME_CONTAINS"],
        "limit": 10,
        "orderBy": { "vesselName": "asc" },
        "bindLabel": "name",
        "bindValue": "id",
        "displayColumns": [{ "key": "code", "header": "Code" },{ "key": "name", "header": "Name" }],
        "additionalFilters": {
          "name": "IS_ACTIVE",
          "alias": "IS_ACTIVE",
          "operator": "EQ",
          "value": ["true"]
        }
      }
    }
  ],
  "useNewContract": true
},

"searchBarConfig": {
    "placeHolder": "Search Vehicle Number",
    "filters": [
      {
        "name": "trailerNumber",
        "alias": "trailerNumber"
      }
    ]
  },

    "vehicleTableConfig": {
        "columns": [
        {
            "fieldName": "trailerNumber",
            "displayName": "Vehicle  No",
            "dataType": "STRING"
        },
              {
            "fieldName": "transporterId",
            "displayName": "Transporter",
            "dataType": "STRING"
        },
              {
            "fieldName": "vehicleTypeId",
            "displayName": "Vehicle Type",
            "dataType": "STRING"
        },
              {
            "fieldName": "processCycle",
            "displayName": "Process Cycle",
            "dataType": "STRING"
        },
              {
            "fieldName": "gateInDate",
            "displayName": "Arrival Date",
            "dataType": "DATETIME"
        },
              {
            "fieldName": "modifiedDate",
            "displayName": "Modified Date",
            "dataType": "DATETIME",
            "sortable": true

        }
        
    ]
    }
}
